module.exports = __webpack_public_path__ + "resources/icon-help.e44427db815023cc.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/game-lottery/img/icon-help.png
// module id = 799
// module chunks = 0 1